<div class="branch-controls-container">
  <div class="branch-controls-header">
    {{ "BRANCH_CONTROLS.HEADER" | translate }}
  </div>

  <div class="sites-stats">
    <app-sites-table [displayedColumns]="displayedColumns"></app-sites-table>
  </div>

  <div class="controls">
    <div class="dropdown-container">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>{{ 'BRANCH_CONTROLS.SELECT_ZONE' | translate }}</mat-label>
        <mat-select [(ngModel)]="selectedZone" (selectionChange)="onZoneChange($event.value)">
          <mat-option *ngFor="let zone of zones" [value]="zone.value">
            {{zone.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width">
        <mat-label>{{ 'BRANCH_CONTROLS.SELECT_CONTROL_TYPE' | translate }}</mat-label>
        <mat-select [(ngModel)]="selectedControlType" (selectionChange)="onControlTypeChange($event.value)"
          [disabled]="!selectedZone">
          <mat-option *ngFor="let type of controlTypes" [value]="type">
            {{ type }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="controls-workspace" *ngIf="selectedControlType && availableControls?.length">
      <div class="controls-grid">
        <button type="button" class="control-btn" *ngFor="let controller of availableControls"
          [class.active]="selectedControl === controller._id"
          [class.is-success]="controllerState[controller._id] === 'success'"
          [class.is-error]="controllerState[controller._id] === 'error'"
          [class.is-busy]="executingId === controller._id" [disabled]="!!executingId"
          [style.--btn-color]="buttonColor(controller)" (click)="onControllerClick(controller)">
          <i class="fa fa-spinner fa-spin" *ngIf="executingId === controller._id" aria-hidden="true"></i>
          <i class="fa" *ngIf="executingId !== controller._id" [ngClass]="buttonIcon(controller)"
            aria-hidden="true"></i>
          <span class="control-btn-name">{{ controller.name }}</span>
        </button>
      </div>

      <ng-container *ngIf="selectedControlType === 'BACnet' && selectedControl">
        <div class="control-panel" *ngIf="getSelectedControlType() as controlType"
          [class.is-on]="controlType === 'switch' && digitalValue"
          [class.is-off]="controlType === 'switch' && !digitalValue" [class.analog-panel]="controlType === 'analog'">

          <ng-container *ngIf="controlType === 'switch'">
            <div class="control-panel-header">
              <div class="control-panel-title">
                <i class="fa fa-power-off" aria-hidden="true"></i>
                <span>Digital</span>
              </div>
              <span class="status-pill" [class.on]="digitalValue" [class.off]="!digitalValue">
                {{ digitalValue ? 'ON' : 'OFF' }}
              </span>
            </div>

            <div class="switch-row">
              <div class="switch-labels">
                <span class="state-label" [class.active]="!digitalValue">OFF</span>
                <label class="ios-toggle">
                  <input type="checkbox" [(ngModel)]="digitalValue" (change)="onDigitalChange($event)"
                    [attr.aria-checked]="digitalValue" aria-label="Toggle digital switch">
                  <span class="slider"></span>
                </label>
                <span class="state-label" [class.active]="digitalValue">ON</span>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="controlType === 'analog'">
            <div class="control-panel-header">
              <div class="control-panel-title">
                <i class="fa fa-sliders" aria-hidden="true"></i>
                <span>Analog</span>
              </div>
              <span class="status-pill analog">{{ analogValue }}</span>
            </div>

            <div class="analog-row">
              <span class="state-label">0</span>
              <mat-slider min="0" max="100" step="1" [(ngModel)]="analogValue" (change)="onAnalogChange($event)"
                aria-label="Analog value">
              </mat-slider>
              <span class="state-label">100</span>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>

    <div class="execute-status"
      *ngIf="selectedControlType === 'HTTP-Request' && availableControls?.length && executeMessage" role="status"
      [class.success]="executeSuccess" [class.error]="!executeSuccess">
      <i class="fa execute-status-icon" [ngClass]="executeSuccess ? 'fa-check-circle' : 'fa-exclamation-circle'"
        aria-hidden="true"></i>
      <span class="execute-status-text">{{ executeMessage }}</span>
      <button type="button" class="execute-status-close" (click)="dismissExecuteMessage()"
        [attr.aria-label]="'CONTROLLERS.CLOSE_STATUS' | translate">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>

    <div class="empty-controllers" *ngIf="selectedControlType && !availableControls?.length">
      {{ 'CONTROLLERS.EMPTY' | translate }}
    </div>
  </div>

</div>